import DOMPurify from 'dompurify';

const UNWANTED_ELEMENTS = [
  'style',
  'script',
  'meta',
  'link',
  'head',
  'title',
  'html',
  'body',
];

const PLAIN_TEXT_ELEMENTS = ['p', 'br', 'img'];

const TEXT_WITH_LINKS_ELEMENTS = [
  'p',
  'br',
  'img',
  'strong',
  'b',
  'i',
  'em',
  'u',
  'a',
];

const processHtmlContent = (htmlContent, allowedTags) => {
  if (!htmlContent || typeof htmlContent !== 'string') {
    return '';
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = DOMPurify.sanitize(htmlContent);

  const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_ELEMENT, {
    acceptNode: () => NodeFilter.FILTER_ACCEPT,
  });

  const elementsToProcess = [];
  let currentNode = walker.nextNode();
  while (currentNode) {
    elementsToProcess.push(currentNode);
    currentNode = walker.nextNode();
  }

  elementsToProcess.reverse().forEach(element => {
    const tagName = element.tagName.toLowerCase();

    if (allowedTags.includes(tagName)) {
      const attributes = Array.from(element.attributes);
      attributes.forEach(attr => {
        const shouldKeep =
          (tagName === 'a' && attr.name === 'href') ||
          (tagName === 'img' && attr.name === 'src');
        if (!shouldKeep) {
          element.removeAttribute(attr.name);
        }
      });
    } else if (UNWANTED_ELEMENTS.includes(tagName)) {
      element.remove();
    } else {
      while (element.firstChild) {
        element.parentNode.insertBefore(element.firstChild, element);
      }
      element.remove();
    }
  });

  return tempDiv.innerHTML;
};

export const textWithLinks = htmlContent => {
  return processHtmlContent(htmlContent, TEXT_WITH_LINKS_ELEMENTS);
};

export const plainTextOnly = htmlContent => {
  return processHtmlContent(htmlContent, PLAIN_TEXT_ELEMENTS);
};

export const processPasteContent = (htmlContent, mode = 'preserve_all') => {
  if (!htmlContent || typeof htmlContent !== 'string') {
    return '';
  }

  switch (mode) {
    case 'text_with_links':
      return textWithLinks(htmlContent);
    case 'plain_text_only':
      return plainTextOnly(htmlContent);
    default:
      return htmlContent;
  }
};
